export default {
  STOCK: '證券',
  FUTURES: '期貨',
  FOREX: '外匯',
  IB: 'EddidPro',
  PM: '現貨黃金',
  FUND: '基金',
  SECURITIES_CASH: '證券(現金)賬戶',
  SECURITIES_MARGIN: '證券(保證金)賬戶',
  FUTURES_MARGIN: '期貨賬戶',
  MT5: '槓桿式外匯交易賬戶',
  MF: '外匯(Eddid FX Pro)賬戶',
  BULLION_MARGIN: '現貨黃金賬戶',
  INTERACTIVE_BROKER_INTEGRATED_MARGIN: 'EddidPro賬戶',
  default: '賬戶',
  SECURITIES_AYERS_CASH: '全權委託證券（現金）賬戶',
  FUTURES_DAYTRADING_MARGIN: '期貨日內交易賬戶',
  FUND_CASH: '基金賬戶'
}
